import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import 'datatables.net-dt/css/dataTables.dataTables.min.css';
import 'datatables.net';
import { authManager } from '../utils/auth';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Base_Url = process.env.REACT_APP_API_BASE_URL;
const limit = 10;
const $ = window.$;

const Brand = () => {
    const navigate = useNavigate();
    const [selectedNetwork, setSelectedNetwork] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedBrand, setSelectedBrand] = useState({ id: '', name: '' });
    const selectedNetworkRef = useRef('');


    const destroyDataTable = useCallback(() => {
        if ($.fn.DataTable.isDataTable('#products')) {
            $('#products').DataTable().clear().destroy();
        }
    }, []);


    const initializeDataTable = useCallback(() => {
        destroyDataTable();
        $('#products').DataTable({
            serverSide: true,
            processing: true,
            ajax: async (dataTablesParams, callback) => {
                const start = dataTablesParams.start || 0;
                const limitPerPage = dataTablesParams.length || limit;
                const page = Math.floor(start / limitPerPage) + 1;
                const searchValue = dataTablesParams.search?.value || '';
                const sortColumnIndex = dataTablesParams.order?.[0]?.column;
                const sortField = dataTablesParams.columns?.[sortColumnIndex]?.data || 'name';
                const sortOrder = dataTablesParams.order?.[0]?.dir || 'asc';
                const network = selectedNetworkRef.current || '';

                const apiUrl = `${Base_Url}/shopping/brands/admin/list?page=${page}&limit=${limitPerPage}&search=${encodeURIComponent(searchValue)}&sortBy=${sortField}&sortOrder=${sortOrder}&network=${network}`;

                try {
                    const response = await authManager.authenticatedFetch(apiUrl);
                    const json = await response.json();

                    const brands = json.result?.brands || [];
                    const totalRecords = json.result?.pagination?.total || 0;

                    const transformed = brands.map((brand, i) => ({
                        serial: start + i + 1,
                        logo: brand.brandLogo,
                        name: brand.name || '-',
                        network: brand.network || '-',
                        description: brand.description || '-',
                        address: brand.address || '-',
                        phone: brand.phoneNumber || '-',
                        email: brand.email || '-',
                        socialmedia: brand.socialLinks || {},
                        TopBrand: brand.isTop || '-',
                        availability: brand.status || '-',
                        _id: brand._id
                    }));
                    callback({
                        recordsTotal: totalRecords,
                        recordsFiltered: totalRecords,
                        data: transformed
                    });
                } catch (error) {
                    console.error('Error fetching brands:', error);
                    callback({
                        recordsTotal: 0,
                        recordsFiltered: 0,
                        data: []
                    });
                }
            },
            columns: [
                { data: 'serial', title: 'S.No', className: 'text-center', orderable: false, width: '60px', },
                {
                    data: 'logo',
                    title: 'Logo',
                    className: 'text-center',
                    orderable: false,
                    width: '120px',
                    render: data =>
                        `<div class="brand_img"><img src="${data || '/assets/img/brands/no_brand.png'}" alt="logo" style="max-width: 120px; max-height: 50px; object-fit: contain"/></div>`
                },
                { data: 'name', title: 'Name', className: 'text-center' },
                { data: 'network', title: 'Affiliate Platforms', className: 'text-center' },
                {
                    data: 'description',
                    title: 'Description',
                    orderable: false,
                    width: '350px',
                    className: 'text-center',
                    render: data => {
                        const text = data.length > 100 ? `${data.slice(0, 100)}...` : data;
                        return `<div title="${data.replace(/"/g, '&quot;')}">${text}</div>`;
                    }

                },
                { data: 'address', title: 'Address', orderable: false, width: '250px', className: 'text-center' },
                { data: 'phone', title: 'Phone', orderable: false, width: '200px', className: 'text-center' },
                { data: 'email', title: 'Email', orderable: false, width: '200px', className: 'text-center' },
                {
                    data: 'socialmedia',
                    title: 'Social Media',
                    orderable: false,
                    width: '200px',
                    render: social => {
                        if (!social) return '-';

                        const getFullUrl = (url) => {
                            if (!url) return '';
                            return url.startsWith('http://') || url.startsWith('https://')
                                ? url
                                : `https://${url}`;
                        };

                        const targetProps = 'target="_blank" rel="noopener noreferrer"';
                        return `
                            <div class="socialmedia_network">
                                ${social.facebook ? `<a href="${getFullUrl(social.facebook)}" ${targetProps}><i class="fa-brands fa-facebook-f"></i></a>` : ''}
                                ${social.twitter ? `<a href="${getFullUrl(social.twitter)}" ${targetProps}><i class="fa-brands fa-x-twitter"></i></a>` : ''}
                                ${social.linkedin ? `<a href="${getFullUrl(social.linkedin)}" ${targetProps}><i class="fa-brands fa-linkedin-in"></i></a>` : ''}
                                ${social.pinterest ? `<a href="${getFullUrl(social.pinterest)}" ${targetProps}><i class="fa-brands fa-pinterest-p"></i></a>` : ''}
                                ${social.youtube ? `<a href="${getFullUrl(social.youtube)}" ${targetProps}><i class="fa-brands fa-youtube"></i></a>` : ''}
                                ${social.instagram ? `<a href="${getFullUrl(social.instagram)}" ${targetProps}><i class="fa-brands fa-instagram"></i></a>` : ''}
                                ${social.threads ? `<a href="${getFullUrl(social.threads)}" ${targetProps}><i class="fa-brands fa-threads"></i></a>` : ''}
                            </div>`;
                    }

                },
                {
                    data: 'TopBrand',
                    title: 'Top Brand',
                    orderable: false,
                    width: '150px',
                    className: 'text-center',
                    render: (isTop, type, row) => {
                        const isTrue = isTop === true || isTop === 'true';
                        const btnClass = isTrue ? 'btn btn-blue' : 'btn-danger';
                        const btnText = isTrue ? 'Active' : 'Inactive';
                        const toggleAttr = isTrue ? 'remove-top' : 'set-top';
                        return `
            <button class="btn ${btnClass} btn-sm toggle-top-brand" 
                    data-id="${row._id}" 
                    data-action="${toggleAttr}">
                ${btnText}
            </button>
        `;
                    }
                },
                {
                    data: 'availability',
                    title: 'Availability',
                    orderable: false,
                    width: '150px',
                    className: 'text-center',
                    render: (status, type, row) => {
                        const isActive = status === 'active';
                        const btnClass = isActive ? 'btn btn-blue' : 'btn-danger';
                        const btnText = isActive ? 'Active' : 'Inactive';
                        return `
                            <button class="btn ${btnClass} btn-sm toggle-status" 
                                    data-id="${row._id}" 
                                    data-status="${status}">
                                ${btnText}
                            </button>
                         `;
                    }
                },


                {
                    data: '_id',
                    title: 'Action',
                    width: '80px',
                    className: 'text-center',
                    orderable: false,
                    render: (id, type, row) => `
                    <div align="center">
                        <i class="fa-solid fa-eye mr-2 crsr_pntr action-icon" data-navigate="/brands/${id}"></i>
                        <i class="fa-solid fa-pen mr-2 crsr_pntr action-icon" data-navigate="/brandsedit/${id}"></i>
                        <i class="fa-solid fa-trash-can crsr_pntr action-icon" data-delete-id="${id}" data-delete-name="${row.name}"></i>
                    </div>`
                }
            ],
            pageLength: limit,
            lengthChange: false,
            responsive: true,
            autoWidth: false,
            paging: true,
            ordering: true,
            searching: true,
            pagingType: 'simple_numbers',
            language: {
                paginate: {
                    next: 'Next',
                    previous: 'Previous'
                }
            },
            drawCallback: function () {
                const tablePosition = document.getElementById('products')?.offsetTop;
                if (tablePosition !== undefined) {
                    window.scrollTo({ top: tablePosition - 100, behavior: 'smooth' });
                }
            }
        });
    }, [destroyDataTable]);


    useEffect(() => {
        initializeDataTable();
    }, [initializeDataTable]);

    useEffect(() => {
        const table = document.getElementById('products');
        if (!table) return;

        const handleClick = (e) => {
            const target = e.target;

            // Toggle brand status
            if (target.classList.contains('toggle-status')) {
                const id = target.getAttribute('data-id');
                const currentStatus = target.getAttribute('data-status');
                const newUrl = currentStatus === 'active'
                    ? `${Base_Url}/shopping/brands/${id}/disable`
                    : `${Base_Url}/shopping/brands/${id}/enable`;

                authManager.authenticatedFetch(newUrl, { method: 'PUT' })
                    .then(res => res.json())
                    .then(data => {
                        if (data.status === 'success') {
                            toast.success(`Brand ${currentStatus === 'active' ? 'disabled' : 'enabled'} successfully`);
                            initializeDataTable();
                        } else {
                            toast.error(data.message || 'Failed to update status');
                        }
                    })
                    .catch(err => {
                        console.error('Error updating status:', err);
                        toast.error('Error updating status');
                    });
                return;
            }

            if (target.classList.contains('toggle-top-brand')) {
                const id = target.getAttribute('data-id');
                const action = target.getAttribute('data-action'); // 'set-top' or 'remove-top'
                const url = `${Base_Url}/shopping/brands/${id}/${action}`;

                authManager.authenticatedFetch(url, { method: 'PUT' })
                    .then(res => res.json())
                    .then(data => {
                        if (data.status === 'success') {
                            toast.success(`Brand ${action === 'set-top' ? 'set as top' : 'removed from top'} successfully`);
                            initializeDataTable();
                        } else {
                            toast.error(data.message || 'Failed to update top brand status');
                        }
                    })
                    .catch(err => {
                        console.error('Error updating top brand status:', err);
                        toast.error('Error updating top brand status');
                    });
                return;
            }

            // Navigate or delete brand
            const navOrDeleteTarget = target.closest('[data-navigate], [data-delete-id]');
            if (!navOrDeleteTarget) return;

            if (navOrDeleteTarget.hasAttribute('data-navigate')) {
                navigate(navOrDeleteTarget.getAttribute('data-navigate'));
            } else if (navOrDeleteTarget.hasAttribute('data-delete-id')) {
                const id = navOrDeleteTarget.getAttribute('data-delete-id');
                const name = navOrDeleteTarget.getAttribute('data-delete-name');
                setSelectedBrand({ id, name });
                setShowDeleteModal(true);
            }
        };

        table.addEventListener('click', handleClick);
        return () => table.removeEventListener('click', handleClick);
    }, [navigate, initializeDataTable]);


    const handleDelete = async () => {
        try {
            const response = await authManager.authenticatedFetch(
                `${Base_Url}/shopping/brands/${selectedBrand.id}`,
                { method: 'DELETE' }
            );

            const json = await response.json();

            if (response.ok) {
                toast.success('Brand deleted successfully');
                setShowDeleteModal(false);
                initializeDataTable();
            } else {
                const errorMsg = json?.error?.errors || 'Failed to delete brand';
                toast.error(errorMsg);
            }
        } catch (error) {
            toast.error('Something went wrong during deletion');
            console.error('Delete error:', error);
        }
    };



    return (
        <div>
            <ToastContainer position="top-right" autoClose={3000} />

            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 txt_lft">Brands</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div className="content">
                <div className="container-fluid">

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="frmwdth_cntr">
                                <div className="col-lg-12">
                                    <div className="card card-primary card-outline">
                                        <form className="form-horizontal" onSubmit={(e) => {
                                            e.preventDefault();
                                            initializeDataTable();
                                        }}>
                                            <div className="card-body">
                                                <div className="form-group row">
                                                    <label className="col-12 col-md-4 col-form-label">Affiliate Platforms</label>
                                                    <div className="col-12 col-md-5 mb-3 mb-md-0">
                                                        <select
                                                            className="form-control"
                                                            value={selectedNetwork}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                setSelectedNetwork(val);
                                                                selectedNetworkRef.current = val;
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="CJ">CJ</option>
                                                            <option value="IMPACT">Impact</option>
                                                            <option value="RAKUTEN">Rakuten Advertising</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-12 col-md-3 text-center">
                                                        <button type="submit" className="btn btn-blue">Search</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="table-responsive">
                                <table
                                    id="products"
                                    className="table table-striped table-bordered txt_lft"
                                    width="100%"
                                >
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Logo</th>
                                            <th>Name</th>
                                            <th>Affiliate Platforms</th>
                                            <th>Description</th>
                                            <th>Address</th>
                                            <th>Phone</th>
                                            <th>Email</th>
                                            <th>Social Media</th>
                                            <th>Top Brand</th>
                                            <th>Availability</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody></tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`modal fade ${showDeleteModal ? 'show' : ''}`}
                id="modaldelete"
                tabIndex={-1}
                aria-labelledby="modaldeleteLabel"
                aria-hidden={!showDeleteModal}
                style={{ display: showDeleteModal ? 'block' : 'none' }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="modaldeleteLabel">Delete Brand</h5>
                            <button type="button" className="close" onClick={() => setShowDeleteModal(false)} aria-label="Close">
                                <i className="fa-solid fa-xmark" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="w-100 d-inline-block text-center">
                                Are you sure you want to delete <br /><span className="fwt_600">{selectedBrand.name}</span>?
                            </div>
                        </div>
                        <div className="modal-footer justify-content-center">
                            <button className="btn btn-secondary me-2" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                            <button className="btn btn-danger" onClick={handleDelete}>Yes, delete</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    );
};

export default Brand;
